import { useState, useEffect } from 'react';

const STORAGE_KEY = 'verveai-sidebar-state';

/**
 * Custom hook to manage sidebar state with localStorage persistence
 * @returns {Object} { isOpen: boolean, setIsOpen: function }
 */
export const useSidebarState = () => {
  // Initialize state from localStorage or default to true (expanded)
  const [isOpen, setIsOpen] = useState(() => {
    try {
      const savedState = localStorage.getItem(STORAGE_KEY);
      return savedState !== null ? JSON.parse(savedState) : true;
    } catch (error) {
      console.warn('Failed to load sidebar state from localStorage:', error);
      return true; // Default to expanded on error
    }
  });

  // Persist state to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isOpen));
    } catch (error) {
      console.warn('Failed to save sidebar state to localStorage:', error);
      // Continue with in-memory state only
    }
  }, [isOpen]);

  return { isOpen, setIsOpen };
};

export default useSidebarState;
